<template>
  <div>
    <el-dialog
        :visible.sync="isOpenUpdateTicketAppDialog"
        width="1720px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="3vh"
        title="Cập nhật phiếu bé ngoan"
        border
    >
      <el-form
          label-width="140px"
          :model="updateTicketAppRequest"
          label-position="left"
          :rules="rules"
          ref="updateTicketAppRequest"
      >
        <el-row :gutter="50">
          <el-col :span="10">
            <div class="grid-content">
              <el-form-item label="Tên phiếu bé ngoan" prop="nameTicket" label-width="170px">
                <el-input
                    v-model="updateTicketAppRequest.nameTicket"
                    placeholder="Nhập tên"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="grid-content">
              <el-form-item label="Mô tả">
                <el-input
                    v-model="updateTicketAppRequest.descriptionTicket"
                    placeholder="Nhập mô tả"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="50">
          <el-col :span="10">
            <el-form-item label="Phiên bản" prop="version" label-width="170px">
              <span>{{ updateTicketAppRequest.version }}</span>
              <el-input-number v-model="version" style="margin-left: 10px" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <div class="grid-content">
              <el-form-item label="Tên trường">
                <h4 class="school_name">
                  {{ updateTicketAppRequest.nameSchool }}
                </h4>
              </el-form-item>

            </div>
          </el-col>
        </el-row>

        <!--    Tên trường    -->
        <el-row>
          <el-col :span="10">
            <el-form-item label="Màn hình" label-width="170px">
              <el-select v-model="displayTicket" placeholder="Chọn màn hình" @change="handleChangeDisplayTicket"
                         style="width: 228px; display: block">
                <el-option
                    style="width: 200px"
                    v-for="item in listDisplayTicket"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="14" style="border: 1px solid #ccc; padding: 10px;">
            <div style="overflow-x: auto">
              <el-row>
                <span><b style="font-size: 17px">Thêm ảnh</b></span>
              </el-row>
              <hr>
              <div>
                <el-upload
                    style="margin-left: 35px; clear: both"
                    action="#"
                    list-type="picture-card"
                    :auto-upload="false"
                    :file-list="fileListTicket"
                    :on-change="handleChangePictureTicket"
                    :on-remove="handleRemoveTicket"
                    :before-remove="beforeRemove"
                    :on-preview="handlePictureCardPreviewTicket"
                    multiple
                    ref="uploadTicket"
                >
                  <i slot="default" class="el-icon-plus" style="font-style: normal; white-space: nowrap">Thêm Ảnh</i>
                </el-upload>
                <el-dialog width="50%" :visible.sync="dialogVisibleTicket">
                  <img width="100%" :src="dialogImageUrlTicket" alt/>
                </el-dialog>
              </div>
            </div>
          </el-col>

          <el-col :span="24">
            <template>
              <el-row>
                <span><b style="font-size: 17px">Danh sách: {{ titleTicket }}</b></span>
              </el-row>
              <hr/>
              <el-row style="
                 display: flex;
                 flex-wrap: wrap;
                 width: 100%;
                 margin-top: 10px;
                 border: 1px solid rgb(96 99 102 / 19%);
                 max-height: 600px;
                 padding-left: 50px;
                 height: 305px"
              >
                <div
                    style="
                    display: flex;
                    width: 100%;
                    overflow-x: hidden;
                    max-height: 600px"
                >
                  <div
                      style="
                      display: flex;
                      transition: all 0.5s linear"
                      :style="{transform: `translateX(-${currentSlideIndex * (100 / (this.listTicketUpdate.length / this.itemsToShow))}%)`}"
                  >
                    <div v-for="item in listTicketUpdate" :key="item.id"
                         style="flex: 0 0 223px; margin: 30px; width: 223px">
                      <div class="inline-block-div">
                        <el-image
                            :src="item.urlPicture"
                            style="width: 200px; height: 200px"
                            @click="handleShowDialogImage(item.urlPicture)"
                        ></el-image>
                        <span class="el-upload-list__item-actions">
                  <el-button
                      type="success"
                      class="el-upload-list__item-preview"
                      @click="deletePicture(item.id)"
                      style="float: left; height: 40px; width: 200px"
                  >
                    <i style="color: white" class="el-icon-delete-solid"></i>
                  </el-button>
                </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container_btn_nav" v-if="listTicketUpdate.length > 0">
              <span
                  class="btn_nav btn-next"
                  style="
                  right: -18px;
                  top: 50%;
                  position: absolute"
                  @click="nextSlide"
                  :style="{cursor: currentSlideIndex === maxIndex ? 'not-allowed' : 'pointer'}"
              >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24" height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-chevron-right"
                >
                  <path d="m9 18 6-6-6-6"/>
                </svg>
              </span>

                  <span
                      class="btn_nav btn-prev"
                      style="
                  left: -18px;
                  top: 50%;
                  position: absolute"
                      @click="prevSlide"
                      :style="{cursor: currentSlideIndex === 0 ? 'not-allowed' : 'pointer'}"
                  >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24" height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-chevron-left"
                >
                  <path d="m15 18-6-6 6-6"/>
                </svg>
              </span>
                </div>
                <el-dialog :modal="false" width="40%" :visible.sync="showDialogImage.idVisibleImage">
                  <img style="height: 400px; object-fit: contain;" width="100%" :src="showDialogImage.urlImage" alt/>
                </el-dialog>
              </el-row>
            </template>
          </el-col>
        </el-row>

        <div class="tab-infor-button">
          <el-button
              type="success"
              size="medium"
              :loading="loadingButton"
              mini
              @click="submitForm('updateTicketAppRequest')"
          >
            <i class="el-icon-circle-check"/>
            <span>Lưu</span>
          </el-button>
          <el-button
              type="danger"
              size="medium"
              @click="closeDialog()"
          >
            <i class="el-icon-circle-close"/>
            <span>Đóng</span>
          </el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="dialogVisibleTemplateDefault">
      <img width="100%" :src="urlTemplateDefault" alt/>
    </el-dialog>
  </div>

</template>

<script>
import {mapActions, mapState} from "vuex";
import {
  listDisplayTicket,
  listTicketRequest,
  parentScreenList,
  plusScreenList,
  teacherScreenList
} from "@/constant/listTemplate";
import templateConfigMixin from "@/global/mixinTemplate/templateConfig.mixin";
import SystemConfigTicket from "@/services/AdminService/SystemConfigTicket";

export default {
  components: {},
  props: {
    isOpenUpdateTicketAppDialog: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      currentSlideIndex: 0,
      itemsToShow: 5,
      showDialogImage: {
        idVisibleImage: false,
        urlImage: "",
      },
      dialogVisibleTemplateDefault: false,
      urlTemplateDefault: '',
      agentList: "",
      checkedKeepPhoto: true,
      disabled: false,
      loadingData: true,
      loadingButton: false,
      dialogVisiblePicture: false,
      showUpload: false,
      version: 0,
      updateTicketAppRequest: {
        id: "",
        idSchool: "",
        nameSchool: "",
        nameTicket: "",
        descriptionTicket: "",
        appType: "plus",
        listMap: {},
        version: "",

      },
      plusScreenList,
      teacherScreenList,
      parentScreenList,
      listIdDelete: [],
      listIdDeleteRequest: [],
      listDisplayTicket,
      displayTicket: 1,
      typePackage: "template",
      listTicketLearnShow: [],
      listTicketEatShow: [],
      listTicketSleepShow: [],
      listTicketToiletShow: [],
      listTicketHealthyShow: [],
      listTicketCommentShow: [],
      listTicketWeekShow: [],
      listTicketMonthShow: [],
      listTicketPeriodicShow: [],
      listTicketRequest,
      titleTicket: '',
      listTicketUpdate: [],
      fileListTicket: [],
      dialogVisibleTicket: false,
      dialogImageUrlTicket: '',
      listTicketLearn: [],
      listTicketEat: [],
      listTicketSleep: [],
      listTicketToilet: [],
      listTicketHealthy: [],
      listTicketComment: [],
      listTicketWeek: [],
      listTicketMonth: [],
      listTicketPeriodic: [],
      listIdTicketDelete: [],
      colorText: "#FFFFFF",
      rules: {
        nameTicket: [
          {
            required: true,
            message: "Không được để trống",
            trigger: "blur",
          },
        ],
        version: [
          {
            required: true,
            message: "Không được để trống",
            trigger: "change",
          }
        ]
      },
    };
  },
  mixins: [
    templateConfigMixin
  ],
  computed: {
    ...mapState('schoolStore', ['agentList']),
    ...mapState('schoolStore', ['schoolList']),
    maxIndex() {
      return Math.ceil(this.listTicketUpdate.length / this.itemsToShow) - 1;
    }
  },
  methods: {
    ...mapActions('schoolStore', ["fetchDataSchoolList"]),
    nextSlide() {
      if (this.currentSlideIndex < this.maxIndex) {
        ++this.currentSlideIndex;
      }
    },
    prevSlide() {
      if (this.currentSlideIndex > 0) {
        --this.currentSlideIndex;
      } else {
        this.currentSlideIndex = -this.maxIndex;
      }
    },
    handleShowDialogImage(url) {
      this.showDialogImage.idVisibleImage = true;
      this.showDialogImage.urlImage = url;
    },

    getFileList(file) {
      return file ? [file] : [];
    },
    showTemplateDefault(url) {
      this.dialogVisibleTemplateDefault = true
      this.urlTemplateDefault = url
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },

    closeDialog() {
      this.clearAllData();
      this.$refs["updateTicketAppRequest"].resetFields();
      this.$emit("dialog-close");
      this.currentSlideIndex = 0
    },
    closeDialogByButton(fromData) {
      this.clearAllData();
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
    },

    clearAllData() {
      this.colorText = "#FFFFFF"
      this.listTicketLearn = []
      this.listTicketEat = []
      this.listTicketSleep = []
      this.listTicketToilet = []
      this.listTicketHealthy = []
      this.listTicketComment = []
      this.listTicketWeek = []
      this.listTicketMonth = []
      this.listTicketPeriodic = []
      this.typePackage = "template"
      this.listTicketUpdate = []
      this.fileListTicket = []
      this.listIdTicketDelete = []
      this.agentList = ""
      this.listIdDelete = []
      this.checkedKeepPhoto = true
      this.loadingData = true
      this.loadingButton = false
      this.dialogVisiblePicture = false
      this.showUpload = false
      this.updateTicketAppRequest =
          {
            idSchool: "",
            nameSchool: "",
            nameTicket: "",
            descriptionTicket: "",
            appType: "plus",
            listMap: {},
          }
      this.handleClearList()
    },

    async getDataInitialUpdateTicketDialog(nameSchool, row) {
      this.updateTicketAppRequest.idSchool = row.idSchool
      let idTemplate = row.id
      this.updateTicketAppRequest.id = row.id;
      this.updateTicketAppRequest.nameSchool = nameSchool;
      this.updateTicketAppRequest.version = row.version;
      this.displayTicket = 1;
      // Tách chuỗi dựa trên dấu chấm
      let parts = this.updateTicketAppRequest.version.split('.');
      this.version = parseInt(parts[parts.length - 1], 10);

      await SystemConfigTicket.getDetailTicketMasterSchool(idTemplate)
          .then((resp) => {
            const data = resp.data.data;

            this.updateTicketAppRequest.nameTicket = data.nameTicket;
            this.updateTicketAppRequest.descriptionTicket = data.descriptionTicket;

            this.listTicketLearnShow = data.listTicketLearn
            this.listTicketEatShow = data.listTicketEat
            this.listTicketSleepShow = data.listTicketSleep
            this.listTicketToiletShow = data.listTicketToilet
            this.listTicketHealthyShow = data.listTicketHealthy
            this.listTicketCommentShow = data.listTicketComment
            this.listTicketWeekShow = data.listTicketWeek
            this.listTicketMonthShow = data.listTicketMonth
            this.listTicketPeriodicShow = data.listTicketPeriodic
            // if (this.updateTemplateAppRequest.appType === "plus") {
            //   for (let i = 0; i < this.plusScreenList.length; i++) {
            //     let plusTemplate = this.plusScreenList[i];
            //     let key = this.plusScreenList[i].key;
            //     for (let j = 0; j < dataList.length; j++) {
            //       let data = dataList[j];
            //       if (data.namePicture === key) {
            //         plusTemplate.id = data.id
            //         plusTemplate.url = data.urlPicture
            //         plusTemplate.urlKeep = data.urlPicture
            //         plusTemplate.showFile = true
            //       }
            //     }
            //   }
            //
            // } else if (this.updateTemplateAppRequest.appType === "teacher") {
            //   for (let i = 0; i < this.teacherScreenList.length; i++) {
            //     let teacherTemplate = this.teacherScreenList[i];
            //     let key = this.teacherScreenList[i].key;
            //     for (let j = 0; j < dataList.length; j++) {
            //       let data = dataList[j];
            //       if (data.namePicture === key) {
            //         teacherTemplate.id = data.id
            //         teacherTemplate.url = data.urlPicture
            //         teacherTemplate.urlKeep = data.urlPicture
            //         teacherTemplate.showFile = true
            //       }
            //     }
            //   }
            // } else {
            //   for (let i = 0; i < this.parentScreenList.length; i++) {
            //     let parentTemplate = this.parentScreenList[i];
            //     let key = this.parentScreenList[i].key;
            //     for (let j = 0; j < dataList.length; j++) {
            //       let data = dataList[j];
            //       if (data.namePicture === key) {
            //         parentTemplate.id = data.id
            //         parentTemplate.url = data.urlPicture
            //         parentTemplate.urlKeep = data.urlPicture
            //         parentTemplate.showFile = true
            //       }
            //     }
            //   }
            // }
            this.handleChangeDisplayTicket();
          })
          .catch((err) => {
            console.log(err);
          });

    },

    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append("id", this.updateTicketAppRequest.id);
          formData.append("idSchool", this.updateTicketAppRequest.idSchool);
          formData.append("nameTicket", this.updateTicketAppRequest.nameTicket);
          formData.append("descriptionTicket", this.updateTicketAppRequest.descriptionTicket);

          // Tách chuỗi dựa trên dấu chấm
          let parts = this.updateTicketAppRequest.version.split('.');
          parts[parts.length - 1] = this.version.toString();
          this.updateTicketAppRequest.version = parts.join('.');
          formData.append("version", this.updateTicketAppRequest.version);
          if (this.listIdTicketDelete.length >= 0) {
            this.listIdDelete.push(...this.listIdTicketDelete)
          }
          formData.append("listIdDelete", this.listIdDelete);
          // if (this.updateTemplateAppRequest.appType === "plus") {
          //   for (let i = 0; i < this.plusScreenList.length; i++) {
          //     if (this.plusScreenList[i].file != null) {
          //       formData.append(`listMap[${this.plusScreenList[i].key}]`, this.plusScreenList[i].file.raw);
          //     }
          //   }
          // } else if (this.updateTemplateAppRequest.appType === "teacher") {
          //   for (let i = 0; i < this.teacherScreenList.length; i++) {
          //     if (this.teacherScreenList[i].file != null) {
          //       formData.append(`listMap[${this.teacherScreenList[i].key}]`, this.teacherScreenList[i].file.raw);
          //     }
          //   }
          // } else {
          //   for (let i = 0; i < this.parentScreenList.length; i++) {
          //     if (this.parentScreenList[i].file != null) {
          //       formData.append(`listMap[${this.parentScreenList[i].key}]`, this.parentScreenList[i].file.raw);
          //     }
          //   }
          // }
          // if (this.updateTemplateAppRequest.appType === "plus") {
          this.addImageTicketFormData(formData, this.listTicketLearn, this.listTicketEat, this.listTicketSleep, this.listTicketToilet,
              this.listTicketHealthy, this.listTicketComment, this.listTicketWeek, this.listTicketMonth, this.listTicketPeriodic)
          // }
          this.loadingButton = true;
          SystemConfigTicket.createTicketAppSchool(formData)
              .then((resp) => {
                this.$message({
                  message: resp.data.message,
                  type: "success",
                });
                setTimeout(() => {
                  this.closeDialog();
                }, 500);
              })
              .catch((err) => {
                this.$message({
                  message: err.response.data.message,
                  type: "error",
                });
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        }
      });
    },

    // findListIdDelete(){
    //   for (let i = 0; i < this.plusScreenList.length; i++) {
    //     for (let j = 0; j < this.listIdDelete.length; j++) {
    //       if (this.plusScreenList[i].file === null && this.listIdDelete[j] === this.plusScreenList[i].id){
    //         this.listIdDeleteRequest.push(this.plusScreenList[i].id)
    //       }
    //     }
    //   }
    //   for (let i = 0; i < this.teacherScreenList.length; i++) {
    //     for (let j = 0; j < this.listIdDelete.length; j++) {
    //       if (this.teacherScreenList[i].file === null && this.listIdDelete[j] === this.teacherScreenList[i].id){
    //         this.listIdDeleteRequest.push(this.teacherScreenList[i].id)
    //       }
    //     }
    //   }
    //   for (let i = 0; i < this.parentScreenList.length; i++) {
    //     for (let j = 0; j < this.listIdDelete.length; j++) {
    //       if (this.parentScreenList[i].file === null && this.listIdDelete[j] === this.parentScreenList[i].id){
    //         this.listIdDeleteRequest.push(this.parentScreenList[i].id)
    //       }
    //     }
    //   }
    // },

    handleRemove(row) {
      if (this.updateTicketAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].file = null;
            this.plusScreenList[i].url = '';
            this.plusScreenList[i].showFile = true;
          }
        }
      } else if (this.updateTicketAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].file = null;
            this.teacherScreenList[i].url = "";
            this.teacherScreenList[i].showFile = true;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].file = null;
            this.parentScreenList[i].url = '';
            this.parentScreenList[i].showFile = true;
          }
        }
      }
    },

    handleClearList() {
      for (let i = 0; i < this.plusScreenList.length; i++) {
        this.plusScreenList[i].file = null;
        this.plusScreenList[i].url = '';
        this.plusScreenList[i].showFile = true;
        this.plusScreenList[i].id = null
        this.plusScreenList[i].showFile = true
        this.plusScreenList[i].disabled = false
        this.plusScreenList[i].urlKeep = ''
      }
      for (let i = 0; i < this.teacherScreenList.length; i++) {
        this.teacherScreenList[i].file = null;
        this.teacherScreenList[i].url = "";
        this.teacherScreenList[i].showFile = true;
        this.teacherScreenList[i].id = null
        this.teacherScreenList[i].showFile = true
        this.teacherScreenList[i].disabled = false
        this.teacherScreenList[i].urlKeep = ''
      }
      for (let i = 0; i < this.parentScreenList.length; i++) {
        this.parentScreenList[i].file = null;
        this.parentScreenList[i].url = '';
        this.parentScreenList[i].showFile = true;
        this.teacherScreenList[i].id = null
        this.teacherScreenList[i].showFile = true
        this.teacherScreenList[i].disabled = false
        this.teacherScreenList[i].urlKeep = ''
      }
    },

    beforeRemove(file) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },
    handlePictureCardPreview(row, file) {
      if (this.updateTicketAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].url = file.url;
            this.plusScreenList[i].dialogImg = true;
          }
        }
      } else if (this.updateTicketAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].url = file.url;
            this.teacherScreenList[i].dialogImg = true;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].url = file.url;
            this.parentScreenList[i].dialogImg = true;
          }
        }
      }
    },

    deleteTemplateSchool(id) {
      console.log("id xóa: ", id)
      this.listIdDelete.push(id)
      for (let i = 0; i < this.plusScreenList.length; i++) {
        if (this.plusScreenList[i].id === id) {
          this.plusScreenList[i].urlKeep = ''
        }
      }
      for (let i = 0; i < this.teacherScreenList.length; i++) {
        if (this.teacherScreenList[i].id === id) {
          this.teacherScreenList[i].urlKeep = ''
        }
      }
      for (let i = 0; i < this.parentScreenList.length; i++) {
        if (this.parentScreenList[i].id === id) {
          this.parentScreenList[i].urlKeep = ''
        }
      }
    },

    handleSelectionSchool() {
      const selectedSchool = this.schoolList.find(item => item.id === this.updateTicketAppRequest.idSchool);
      this.updateTicketAppRequest.nameSchool = selectedSchool.schoolName;
    },

    handleChangePicture(row, file) {
      if (this.updateTicketAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].file = file;
            this.plusScreenList[i].url = file.url;
            this.plusScreenList[i].showFile = false;
          }
        }
      } else if (this.updateTicketAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].file = file;
            this.teacherScreenList[i].url = file.url;
            this.teacherScreenList[i].showFile = false;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].file = file;
            this.parentScreenList[i].url = file.url;
            this.parentScreenList[i].showFile = false;
          }
        }
      }
      this.checkedKeepPhoto = false
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemove(file);
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemove(file);
      }
      return isJPG && isLt5M;
    },

    handleTypeApp() {
      if (this.updateTicketAppRequest.appType !== 'plus') {
        this.typePackage = 'template'
        console.log("382167389127321893")
      }
    },

    handleChangeDisplayTicket() {
      this.listTicketUpdate = []
      this.titleTicket = this.getNameTicket(this.displayTicket)
      switch (this.displayTicket) {
        case 1: {
          this.listTicketUpdate = this.listTicketLearnShow
          this.fileListTicket = this.listTicketLearn
          break;
        }
        case 2: {
          this.listTicketUpdate = this.listTicketEatShow
          this.fileListTicket = this.listTicketEat
          break;
        }
        case 3: {
          this.listTicketUpdate = this.listTicketSleepShow
          this.fileListTicket = this.listTicketSleep
          break;
        }
        case 4: {
          this.listTicketUpdate = this.listTicketToiletShow
          this.fileListTicket = this.listTicketToilet
          break;
        }
        case 5: {
          this.listTicketUpdate = this.listTicketHealthyShow
          this.fileListTicket = this.listTicketHealthy
          break;
        }
        case 6: {
          this.listTicketUpdate = this.listTicketCommentShow
          this.fileListTicket = this.listTicketComment
          break;
        }
        case 7: {
          this.listTicketUpdate = this.listTicketWeekShow
          this.fileListTicket = this.listTicketWeek
          break;
        }
        case 8: {
          this.listTicketUpdate = this.listTicketMonthShow
          this.fileListTicket = this.listTicketMonth
          break;
        }
        case 9: {
          this.listTicketUpdate = this.listTicketPeriodicShow
          this.fileListTicket = this.listTicketPeriodic
          break;
        }
      }
    },
    handleChangeTypeTicket() {
      this.currentSlideIndex = 0;
      if (this.typePackage === 'ticket') {
        this.handleChangeDisplayTicket();
      }
    },

    // Chọn ảnh phiếu bé ngoan
    handleChangePictureTicket(file, fileList) {
      this.fileListTicket = fileList
      switch (this.displayTicket) {
        case 1: {
          this.listTicketLearn = this.fileListTicket
          break;
        }
        case 2: {
          this.listTicketEat = this.fileListTicket
          break;
        }
        case 3: {
          this.listTicketSleep = this.fileListTicket
          break;
        }
        case 4: {
          this.listTicketToilet = this.fileListTicket
          break;
        }
        case 5: {
          this.listTicketHealthy = this.fileListTicket
          break;
        }
        case 6: {
          this.listTicketComment = this.fileListTicket
          break;
        }
        case 7: {
          this.listTicketWeek = this.fileListTicket
          break;
        }
        case 8: {
          this.listTicketMonth = this.fileListTicket
          break;
        }
        case 9: {
          this.listTicketPeriodic = this.fileListTicket
          break;
        }
      }
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemoveTicket(file);
        return false; // Trả về false để không thực hiện tiếp tục xử lý
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemoveTicket(file);
        return false; // Trả về false để không thực hiện tiếp tục xử lý
      }
      return true;
    },
    // Xem chi tiết ảnh phiếu bé ngoan
    handlePictureCardPreviewTicket(file) {
      this.dialogImageUrlTicket = file.url;
      this.dialogVisibleTicket = true;
    },
    // Xóa file phiếu bé ngoan
    handleRemoveTicket(file) {
      this.$refs.uploadTicket.clearFiles();
      let index;
      for (let i = 0; i < this.fileListTicket.length; i++) {
        if (file.uid === this.fileListTicket[i].uid) {
          index = i
        }
      }
      if (index >= 0) {
        this.fileListTicket.splice(index, 1);
      }
      let indexTicket;
      switch (this.displayTicket) {
        case 1: {
          for (let i = 0; i < this.listTicketLearn.length; i++) {
            if (file.uid === this.listTicketLearn[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketLearn.splice(indexTicket, 1);
          }
          break;
        }
        case 2: {
          for (let i = 0; i < this.listTicketEat.length; i++) {
            if (file.uid === this.listTicketEat[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketEat.splice(indexTicket, 1);
          }
          break;
        }
        case 3: {
          for (let i = 0; i < this.listTicketSleep.length; i++) {
            if (file.uid === this.listTicketSleep[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketSleep.splice(indexTicket, 1);
          }
          break;
        }
        case 4: {
          for (let i = 0; i < this.listTicketToilet.length; i++) {
            if (file.uid === this.listTicketToilet[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketToilet.splice(indexTicket, 1);
          }
          break;
        }
        case 5: {
          for (let i = 0; i < this.listTicketHealthy.length; i++) {
            if (file.uid === this.listTicketHealthy[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketHealthy.splice(indexTicket, 1);
          }
          break;
        }
        case 6: {
          for (let i = 0; i < this.listTicketComment.length; i++) {
            if (file.uid === this.listTicketComment[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketComment.splice(indexTicket, 1);
          }
          break;
        }
        case 7: {
          for (let i = 0; i < this.listTicketWeek.length; i++) {
            if (file.uid === this.listTicketWeek[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketWeek.splice(indexTicket, 1);
          }
          break;
        }
        case 8: {
          for (let i = 0; i < this.listTicketMonth.length; i++) {
            if (file.uid === this.listTicketMonth[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketMonth.splice(indexTicket, 1);
          }
          break;
        }
        case 9: {
          for (let i = 0; i < this.listTicketPeriodic.length; i++) {
            if (file.uid === this.listTicketPeriodic[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketPeriodic.splice(indexTicket, 1);
          }
          break;
        }
      }
    },

    deletePicture(id) {
      this.$confirm("Bạn có chắc chắn muốn xóa ảnh đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
      }).then(() => {
        let indexTicket;
        switch (this.displayTicket) {
          case 1: {
            for (let i = 0; i < this.listTicketLearnShow.length; i++) {
              if (id === this.listTicketLearnShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketLearnShow.splice(indexTicket, 1);
            }
            break;
          }
          case 2: {
            for (let i = 0; i < this.listTicketEatShow.length; i++) {
              if (id === this.listTicketEatShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketEatShow.splice(indexTicket, 1);
            }
            break;
          }
          case 3: {
            for (let i = 0; i < this.listTicketSleepShow.length; i++) {
              if (id === this.listTicketSleepShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketSleepShow.splice(indexTicket, 1);
            }
            break;
          }
          case 4: {
            for (let i = 0; i < this.listTicketToiletShow.length; i++) {
              if (id === this.listTicketToiletShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketToiletShow.splice(indexTicket, 1);
            }
            break;
          }
          case 5: {
            for (let i = 0; i < this.listTicketHealthyShow.length; i++) {
              if (id === this.listTicketHealthyShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketHealthyShow.splice(indexTicket, 1);
            }
            break;
          }
          case 6: {
            for (let i = 0; i < this.listTicketCommentShow.length; i++) {
              if (id === this.listTicketCommentShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketCommentShow.splice(indexTicket, 1);
            }
            break;
          }
          case 7: {
            for (let i = 0; i < this.listTicketWeekShow.length; i++) {
              if (id === this.listTicketWeekShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketWeekShow.splice(indexTicket, 1);
            }
            break;
          }
          case 8: {
            for (let i = 0; i < this.listTicketMonthShow.length; i++) {
              if (id === this.listTicketMonthShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketMonthShow.splice(indexTicket, 1);
            }
            break;
          }
          case 9: {
            for (let i = 0; i < this.listTicketPeriodicShow.length; i++) {
              if (id === this.listTicketPeriodicShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketPeriodicShow.splice(indexTicket, 1);
            }
            break;
          }
        }
        this.listIdTicketDelete.push(id)
        this.$message({
          message: "Xóa ảnh thành công",
          type: "success",
        });
      });
    },

  },
};
</script>
<style>
.hideUpload > div {
  visibility: hidden;
}
</style>
<style lang="scss" scoped>

/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #67c23a;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .el-upload--picture-card {
  background: none;
  border-radius: 6px;
  border: none; /* Default border */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}

/deep/ .el-table th.gutter {
  background-color: #78a5e7;
}

/deep/ .el-image__error {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #ffffff;
  vertical-align: middle;
}

.app_name {
  display: inline-block;
  margin: 0;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0 12px;
  cursor: not-allowed;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.school_name {
  margin: 0;
  color: #3a8ee6;
  font-weight: 900;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/deep/ .el-upload-list__item.is-ready > div {
  height: 100%;
}

.tag_image {
  background: #409effe6;
  position: absolute;
  left: -20px;
  top: -4px;
  width: 60px;
  padding: 6px 0 0 0;
  text-align: center;
  color: #fff;
  rotate: -45deg;
  font-size: 12px;
  text-transform: capitalize;
}

/deep/ .el-image__inner {
  object-fit: cover;
}

.btn_nav {
  background-color: #ecf4ff;
  display: flex;
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.8s ease-in-out;
}

.btn_nav:hover {
  background-color: #d3e4fb;
}
</style>
